export default __webpack_public_path__ + "static/media/visa_logo.51370d36.png";